import * as React from "react";
import * as yup from "yup";
import { withRouter, RouteComponentProps } from "react-router-dom";

import { ApolloClient, withApollo } from "../react-apollo";
import { withSession, SessionProps } from "../session";
import { ChallengeFragment, challengeAccept } from "../graphql/challenge";
import { Button, Modal } from "../semantic-ui";
import { Formik, Form } from "../formik";
import UserLink from "../user/UserLink";
import ArmyInput from "../board/ArmyInput";
import { gameUrl } from "../urls";

const acceptChallengeSchema = yup.object().shape({
  recipientArmy: yup.string().required(),
  recipientColor: yup.string().required(),
});

const OTHER_COLOR = {
  white: "black",
  black: "white",
  random: "random",
};

type Props = SessionProps &
  RouteComponentProps & {
    client: ApolloClient<any>;
    challenge: ChallengeFragment;
    onChange?: (arg0: any) => void;
    show: boolean;
    onHide?: () => void;
  };

class AcceptChallengeModal extends React.Component<Props> {
  handleSubmit = (values: any) => {
    const variables = {
      id: this.props.challenge.id,
      ...values,
    };
    this.props.client
      .mutate({
        mutation: challengeAccept,
        variables,
      })
      .then(({ data }) => {
        const game = data.challengeAccept.game;
        if (this.props.me && game.white.id === this.props.me.id) {
          this.props.history.push(gameUrl(game.id));
        } else if (this.props.onChange) {
          this.props.onChange(data.challengeAccept);
        }
      });
  };

  render() {
    const { challenge, show, onHide } = this.props;
    return (
      <Formik
        initialValues={{
          recipientArmy: "",
          recipientColor:
            OTHER_COLOR[challenge.senderColor as keyof typeof OTHER_COLOR],
        }}
        onSubmit={this.handleSubmit}
        validationSchema={acceptChallengeSchema}
      >
        <Modal open={show} onClose={onHide} as={Form}>
          <Modal.Header>
            <UserLink user={challenge.sender} capitalize /> sent you a challenge
          </Modal.Header>
          <Modal.Content>
            <Form.Group inline>
              <label>Which color will you play?</label>
              <Form.Radio
                label="white"
                value="white"
                name="recipientColor"
                disabled={!!challenge.senderColor}
              />
              <Form.Radio
                label="black"
                value="black"
                name="recipientColor"
                disabled={!!challenge.senderColor}
              />
              <Form.Radio
                label="random"
                value="random"
                name="recipientColor"
                disabled={!!challenge.senderColor}
              />
            </Form.Group>
            <Form.Field
              label="Which army will you play?"
              name="recipientArmy"
              control={ArmyInput}
            />
          </Modal.Content>
          <Modal.Actions>
            <Button primary type="submit">
              Accept Challenge
            </Button>
          </Modal.Actions>
        </Modal>
      </Formik>
    );
  }
}

export default withApollo(withRouter(withSession(AcceptChallengeModal)));
